import { render, staticRenderFns } from "./BaseButton.vue?vue&type=template&id=65adba0c&scoped=true&"
import script from "./BaseButton.vue?vue&type=script&lang=ts&"
export * from "./BaseButton.vue?vue&type=script&lang=ts&"
import style0 from "./BaseButton.vue?vue&type=style&index=0&id=65adba0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65adba0c",
  null
  
)

export default component.exports